export default {
    productGroupFactors: [],
    productGroupFactorsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters,
}

function setInitialFilters() {
    return {
        productTypeGroup__name: null,
        kind_id: 20
    }
}